<template>
  <div>
    <div class="page-head">
      <div>
        <h2>工作台总览</h2>
        <p>查看咨询、订单、待处理事项和业务数据变化。</p>
      </div>
    </div>
    <el-row :gutter="16">
      <el-col v-for="item in metrics" :key="item.label" :span="6">
        <el-card class="metric-card" shadow="never">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </el-card>
      </el-col>
    </el-row>
    <el-card class="panel-card" shadow="never">
      <div slot="header">快捷入口</div>
      <el-alert
        title="后台只管理业务数据，不提供小程序装修、底部导航配置或新增付款产品类型。"
        type="info"
        show-icon
        :closable="false"
      />
    </el-card>
    <el-card class="panel-card" shadow="never">
      <div slot="header">订单成本结构</div>
      <div v-if="expenseCategories.length" class="cost-list">
        <div v-for="item in expenseCategories" :key="item.category" class="cost-row">
          <div><span>{{ item.category }}</span><strong>¥{{ Number(item.amount || 0).toFixed(2) }}</strong></div>
          <el-progress :percentage="item.percentage" :show-text="false" color="#c49a50" />
        </div>
      </div>
      <el-empty v-else description="暂无已确认成本" :image-size="72" />
    </el-card>
  </div>
</template>

<script>
import { listResource } from "../api/resources";
import http from "../api/http";

export default {
  name: "Dashboard",
  data() {
    return {
      expenseCategories: [],
      metrics: [
        { label: "今日咨询", value: 0 },
        { label: "今日订单", value: 0 },
        { label: "待跟进需求", value: 0 },
        { label: "待审核评价", value: 0 },
        { label: "合同总额", value: "¥0.00" },
        { label: "确认收入", value: "¥0.00" },
        { label: "确认成本", value: "¥0.00" },
        { label: "经营利润", value: "¥0.00" },
        { label: "待结佣金", value: "¥0.00" }
      ]
    };
  },
  mounted() {
    this.fetchMetrics();
  },
  methods: {
    async fetchMetrics() {
      try {
        const [res, financeRes] = await Promise.all([
          listResource("statistics", { page: 1, pageSize: 10 }),
          http.get("/order-finance/overview")
        ]);
        const items = res.data && res.data.items ? res.data.items : [];
        const finance = financeRes.data || {};
        const totalExpense = Number(finance.confirmed_expense || 0);
        this.expenseCategories = (finance.expense_categories || []).map((item) => ({
          ...item,
          percentage: totalExpense > 0 ? Math.round(Number(item.amount || 0) / totalExpense * 100) : 0
        }));
        const wanted = ["今日咨询", "今日订单", "待跟进需求", "待审核评价"];
        this.metrics = wanted.map((label) => {
          const match = items.find((item) => item.name === label);
          return { label, value: match ? match.value : 0 };
        }).concat([
          { label: "合同总额", value: `¥${Number(finance.contract_amount || 0).toFixed(2)}` },
          { label: "确认收入", value: `¥${Number(finance.confirmed_income || 0).toFixed(2)}` },
          { label: "确认成本", value: `¥${Number(finance.confirmed_expense || 0).toFixed(2)}` },
          { label: "经营利润", value: `¥${Number(finance.profit || 0).toFixed(2)}` },
          { label: "待结佣金", value: `¥${Number(finance.pending_commission || 0).toFixed(2)}` }
        ]);
      } catch (error) {
        this.$message.error(error.message || "工作台数据加载失败");
      }
    }
  }
};
</script>

<style scoped>
.cost-list{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 30px}.cost-row>div{display:flex;justify-content:space-between;margin-bottom:8px}.cost-row span{color:#606266}.cost-row strong{color:#303133}
</style>
